var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEcontomatFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3319.209 -7.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ofis_za_vzimane_stroke",
    "data-name": "Ofis za vzimane stroke",
    transform: "translate(3319.209 7.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13037",
    "data-name": "Group 13037",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13037",
    "data-name": "Rectangle 13037",
    width: 16,
    height: 16,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13037_-_Outline",
    "data-name": "Rectangle 13037 - Outline",
    d: "M1,1V15H15V1H1M0,0H16V16H0Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36070",
    "data-name": "Group 36070",
    transform: "translate(-13297 -9400.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32632",
    "data-name": "Path 32632",
    d: "M10.386,2h-6.8A2.335,2.335,0,0,0,1.337,3.984L.019,13.905A1.7,1.7,0,0,0,1.742,15.89h6.8a2.168,2.168,0,0,0,2.085-1.843,1.58,1.58,0,0,0-1.6-1.843H4.212l.87-6.52H9.9a2.168,2.168,0,0,0,2.085-1.843A1.58,1.58,0,0,0,10.386,2Z",
    transform: "translate(13298.998 9400)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1657",
    "data-name": "Ellipse 1657",
    cx: 2.197,
    cy: 2.197,
    r: 2.197,
    transform: "translate(13304.734 9406.748)",
    fill: "#212121"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcontomatFilter);
export default __webpack_public_path__ + "static/media/econtomat_filter.b2a6bd2c876b330470b9557e84ed938b.svg";
export { ForwardRef as ReactComponent };